module.exports = __webpack_public_path__ + "static/img/8.2a886e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/sp/8.png
// module id = bWzv
// module chunks = 0